import CustomerCareLocaleKeys from '../../../locales/keys';
import { clearSearchResults, setSearchType } from '../../../reducers/actions/search.actions';
import { SEARCH_DROPDOWN_CONSTANTS } from '../search.constants';
import { CoreLocaleKeys, i18n, SessionSelectors } from 'invision-core';
import { getGiftCardSearch, resetGiftCardSearchRecoverable, routeToGiftCard } from '../../../reducers/actions/search.giftcard.actions';
import { GiftCardSearchCurrentPageNumberSelector, GiftCardSearchMapSelector, GiftCardSearchRecordCountSelector, GiftCardSearchTotalPageCountSelector } from '../../../reducers/selectors/search.giftcard.selectors';
export function SearchGiftCardResultsController($ngRedux) {
  var _this = this;
  var disconnectRedux;
  var mapStateToTarget = function mapStateToTarget(store) {
    return {
      giftCardSearchResults: GiftCardSearchMapSelector(store),
      giftCardSearchResultCount: GiftCardSearchRecordCountSelector(store),
      currentPageNumber: GiftCardSearchCurrentPageNumberSelector(store),
      totalPageCount: GiftCardSearchTotalPageCountSelector(store),
      pageSize: SessionSelectors.PageSizePreferenceSelector(store)
    };
  };
  this.$onInit = function () {
    _this.customerCareLocaleKeys = CustomerCareLocaleKeys;
    var controllerActions = {
      clearSearchResults: clearSearchResults,
      getGiftCardSearch: getGiftCardSearch,
      resetGiftCardSearchRecoverable: resetGiftCardSearchRecoverable,
      routeToGiftCard: routeToGiftCard,
      setSearchType: setSearchType
    };
    disconnectRedux = $ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
      _this.state = state;
      _this.actions = actions;
    });
    _this.getRecordCount = function () {
      var firstRecordNumberOnPage = _this.state.currentPageNumber * _this.state.pageSize + 1 - _this.state.pageSize;
      var lastRecordNumberOnPage = Math.min(_this.state.currentPageNumber * _this.state.pageSize, _this.state.giftCardSearchResultCount);
      return i18n.translate(CoreLocaleKeys.PAGING_FOOTER, {
        pageRecordFirst: firstRecordNumberOnPage,
        pageRecordLast: lastRecordNumberOnPage,
        totalRecordCount: _this.state.giftCardSearchResultCount
      });
    };
    _this.clearResults = function () {
      _this.actions.clearSearchResults();
      _this.actions.setSearchType(SEARCH_DROPDOWN_CONSTANTS.GIFT_CARD);
      _this.actions.resetGiftCardSearchRecoverable();
    };
    _this.giftCardClicked = function (giftCardId) {
      var giftCard = _this.state.giftCardSearchResults[giftCardId];
      _this.actions.routeToGiftCard(giftCard);
    };
    _this.pageSelected = function (pageNum) {
      _this.onPageChange()(pageNum);
      _this.actions.getGiftCardSearch(_this.giftCardSearchModel, pageNum, _this.state.pageSize);
    };
  };
  this.$onDestroy = function () {
    disconnectRedux();
  };
}
export var SearchGiftCardResults = {
  template: require('./search.giftcard.results.html'),
  controller: SearchGiftCardResultsController,
  bindings: {
    giftCardSearchModel: '<',
    pageNumber: '<',
    onPageChange: '&'
  }
};